import React from 'react';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';

import './ServicesSection.scss';
import CategoryLink from './CategoryLink';

export default () => {
  const profile = useAppSelector(state => sellerProfilesSelectors.selectAll(state)[0]);

  return (
    <div>
      <ul styleName="services-list">
        { profile?.relationships.autodealCategories.data.map(category =>
          <CategoryLink id={category.id} key={`category_key_${category.id}`} />) }
      </ul>
    </div>
  );
};
